module.exports = "/assets/data/9cb2a0f9072179e171c94eee0f0ac5f1-SL7.data.json";